import "../../Styles/ClientSetupHeader.css";
import { IoChevronBackOutline } from "react-icons/io5";

function ClientSetupHeader({ currentStep, onBack }) {
  return (
    <div className="client-setup-header-main">
      <div className="client-setup-header-left">
        {currentStep !== 4 && onBack && (
          <button
            type="button"
            className="client-setup-back-button"
            onClick={onBack}
          >
            <IoChevronBackOutline aria-hidden="true" />
            {/* <span>Back</span> */}
          </button>
        )}

        <img
          src={require("../../assests/images/nav_bar_logo.png")}
          alt="Wedluk Logo"
          className="client-setup-logo"
        />
      </div>

      <div className="client-setup-header-right">
        {/* <span>Client Sign up | Client setup</span> */}
      </div>
    </div>
  );
}

export default ClientSetupHeader;
